import { Pipe, type PipeTransform } from '@angular/core';
import { Tier } from '@markant-platform/cartridge/model';

@Pipe({
  name: 'sortTiers',
  standalone: true,
  pure: true,
})
export class SortTiersPipe implements PipeTransform {
  transform(tiers: Tier[], sortDirection: 'DESC' | 'ASC' = 'ASC'): Tier[] {
    return [...tiers].sort((p, n) => {
      return sortDirection === 'ASC' ? p.minimalNumber - n.minimalNumber : n.minimalNumber - p.minimalNumber;
    });
  }
}
